'use client'

import { ProductFormatted } from '@/types/product'
import { ProductCard } from '../product-card'
interface ProductListProps {
  products: ProductFormatted[]
}

export function ProductList({ products }: ProductListProps) {
  return (
    <div className='grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'>
      {products.map((product, index) => (
        <ProductCard key={index} product={product} />
      ))}
    </div>
  )
}
